<template>
  <layout-auth>
    <v-toolbar flat color="grey lighten-3" height="50px">
      <v-container>
        <a
          class="sub-nav"
          style="font-weight: bold; color: #222222 !important"
          >{{ $t("invoices.Alta") }}</a
        >
        <a @click="$router.push('/anticipo-automatico/baja')" class="sub-nav">{{
          $t("invoices.Baja")
        }}</a>
        <a
          @click="$router.push('/anticipo-automatico/consulta')"
          class="sub-nav"
        >
          {{ $t("invoices.Modificación") }}
        </a>
      </v-container>
    </v-toolbar>
    <v-container class="py-10">
      <v-row>
        <v-col style="padding-bottom: 0px !important">
          <h1 class="text-h4 font-weight-light">
            {{ $t("invoices.anticipoAutomatico") }}
          </h1>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p>{{ $t("invoices.solicitudDatosRequeridos2") }}</p>

          <h1 class="text-h5 font-weight-light pt-5">
            {{ $t("invoices.datosSolicitud") }}
          </h1>

          <h3 class="text-subtitle-1 font-weight-medium py-2">
            {{ $t("invoices.datosRequeridos") }}
          </h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12" md="4" lg="4" xl="3">
          <label>{{ $t("supplierData.clientCompanyName") }}</label>
          <v-autocomplete
            v-model="form.numClient"
            :color="entityConfig.primaryColor"
            :item-color="entityConfig.primaryColor"
            :items="payingCustomer"
            item-text="name"
            item-value="numClient"
            no-data-text=""
            dense
            outlined
            return-object
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="4" xl="3">
          <label>{{ $t("invoices.cuentaAbono") }} </label>
          <v-autocomplete
            v-model="form.iban"
            :color="entityConfig.primaryColor"
            :item-color="entityConfig.primaryColor"
            :items="accounts"
            item-text="iban"
            item-value="iban"
            no-data-text=""
            dense
            outlined
            return-object
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h3 class="text-h5 font-weight-light py-3" v-if="!hiddenCheck">
            {{ $t("invoices.necesarioAcepte") }}
          </h3>
          <checkbox-terms :checkboxData="entityConfig.checkboxAnticipoAutomatico" @accepted="checkbox = true" @canceled="checkbox = false" />

        </v-col>
      </v-row>

      <v-row class="pb-5">
        <v-col cols="12" sm="12" lg="12" xl="12">
          <v-btn
            depressed
            :color="entityConfig.primaryColor"
            :style="`color: ${entityConfig.secondaryColor}`"
            class="float-end v-btn-width-default"
            @click="confirm"
            :disabled="!form.iban || !form.numClient || !checkbox"
          >
            Aceptar
          </v-btn>
        </v-col>
        <v-col></v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialogNoAccounts" persistent max-width="500">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <p class="text-body-1">
            Para realizar operaciones de anticipo automático debe tener al menos
            una <em>Cuenta de Abono</em> validada.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            dark
            depressed
            class="v-btn-width-default"
            :color="entityConfig.primaryColor"
            :style="`color: ${entityConfig.secondaryColor}`"
            @click="dialogNoAccounts = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <overlay :visible="spinner" :opacity="1"></overlay>
  </layout-auth>
</template>

<script>
import Overlay from "../../components/layouts/overlay.vue";
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import CheckboxTerms from "../../components/layouts/checkbox-terms.vue";
import Api from "../../Services/index";

export default {
  components: { LayoutAuth, Overlay, "checkbox-terms": CheckboxTerms },
  data() {
    return {
      lopdDialog: false,
      showConfirmDialog: false,
      entityConfig: {},
      checkbox: false,
      accounts: [],
      payingCustomer: [],
      numClientAnticipos: [],
      numClientClientes: [],
      numClientAnticiposData: [],
      dialogNoAccounts: false,
      hiddenCheck: false,
      spinner: true,
      form: {
        iban: null,
        numClient: null,
      },
    };
  },
  async mounted() {
    this.spinner = true;
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");
    let autoAdvance = JSON.parse(sessionStorage.getItem("autoAdvance"));
    if (autoAdvance) {
      this.form = autoAdvance;
    }

    this.entityConfig = this.$store.state.entityConfig.config;
    this.hiddenCheck = this.entityConfig.checkboxAnticipoAutomatico?.type == 'hidden';

    this.getAccountList();
    await this.getClientsWithOutAutoAdvances();
  },
  methods: {
    getAccountList() {
      let userdata = JSON.parse(sessionStorage.getItem("userData"));
      let userId = userdata.supplierId.trim();
      Api.get(`/proveedores/${userId}/cuentas-abono-total`)
        .then((res) => {
          this.accounts = res.data.response;
        })
        .catch(() => {
          this.dialogNoAccounts = true;
        });
    },
    async getClientsWithOutAutoAdvances() {      
      let userdata = JSON.parse(sessionStorage.getItem("userData"));
      let supplierId = userdata.supplierId.trim();
      let userId = userdata.supplierId.trim();
      let anticipos = [];
      let clients = [];
      try {
        let response = await Api.get(`/proveedores/${supplierId}/anticipos-automaticos`);
        anticipos = response.data.response.automaticAdvanceInfoList;
      } catch (error) {
        anticipos = [];
      }

      try {
        let response = await Api.get(`/proveedores/${userId}/clientes`);
        clients = response.data.response;
        this.payingCustomer = clients.filter((obj1) => !anticipos.some((obj2) => obj1.numClient == obj2.numClient));
      } catch (error) {
         clients = [];
      } finally {
         this.spinner = false;
      }
    },
    getAutomaticAdvances() {
      let userdata = JSON.parse(sessionStorage.getItem("userData"));
      let supplierId = userdata.supplierId.trim();
      return Api.get(`/proveedores/${supplierId}/anticipos-automaticos`);
    },

    getClientList() {
      let userdata = JSON.parse(sessionStorage.getItem("userData"));
      let userId = userdata.supplierId.trim();
      return Api.get(`/proveedores/${userId}/clientes`);
    },
    confirm() {
      sessionStorage.setItem("autoAdvance", JSON.stringify(this.form));
      this.$router.push("/anticipo-automatico/alta/confirmar");
    },
  },
};
</script>
